import { Form } from 'antd';

import StepContainer from './StepContainer';
import FundingAccountPicker from './FundingAccountPicker';

const FundingAccountStep = ({
  fundingAccount,
  setFundingAccount,
  canAddFundingAccount = true,
  onContinue = () => {},
}) => {
  const [form] = Form.useForm();

  const onFundingAccountConfirmation = async () => {
    try {
      await form.validateFields();
    } catch {
      return;
    }
    onContinue();
  };

  return (
    <StepContainer
      title="Select a Funding Account"
      information="Customers can edit their bank account at any time during the life of their plan"
      onContinue={onFundingAccountConfirmation}
      buttonText="Confirm Funding Account"
    >
      <FundingAccountPicker
        form={form}
        formName="fundingAccount"
        initialValues={{ fundingAccount: fundingAccount?.id || null }}
        onSelect={setFundingAccount}
        canAdd={canAddFundingAccount}
      />
    </StepContainer>
  );
};

export default FundingAccountStep;
